<template>
  <div class="open fs32">
    <div>开启微信推送</div>
    <div>
      <van-switch
        v-model="checked"
        class="switch"
        @change="handleSwitch"
        :active-value="1"
        :inactive-value="0"
        active-color="#1989fa"
        inactive-color="#ccc"
        size="24"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false
    };
  },

  created() {
    this.getInfo();
  },

  methods: {
    // 获取
    async getInfo() {
      await this.$api.getWxPushSwitch().then(res => {
        if (res.errcode === 0 && res.wxUser) {
          this.checked = res.wxUser.notify ? 1 : 0;
        } else {
          this.$toast(res.errmsg);
        }
      });
    },

    // 修改
    async handleSwitch(value) {
      // 先置反 等待请求结果回来在置回去
      this.checked = value == 1 ? 0 : 1;

      console.log("value:", value);

      await this.$api
        .setWxPushSwitch({
          checked: value == 1 ? true : false
        })
        .then(res => {
          if (res.errcode === 0) {
            this.checked = value;
            this.$toast(`${value == 1 ? "打开" : "关闭"}成功`);
          } else {
            this.$toast(`${value == 1 ? "打开" : "关闭"}失败，${res.errmsg}`);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.open {
  display: flex;
  justify-content: space-between;
  // font-size: 24px;
  padding: 0.2rem 0.3rem;
}
</style>
